import { render } from "./my-address.vue?vue&type=template&id=e0f37eea&scoped=true"
import script from "./my-address.vue?vue&type=script&lang=js"
export * from "./my-address.vue?vue&type=script&lang=js"

import "./my-address.vue?vue&type=style&index=0&id=e0f37eea&scoped=true&lang=css"
import "./my-address.vue?vue&type=style&index=1&id=e0f37eea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0f37eea"]])

export default __exports__